import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setBannersLinhaWithText() {
  const sections = document.querySelectorAll('[data-banner-linha-with-text]');

  sections.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    new Swiper(carousel, {
      modules: [Pagination, Navigation],
      slidesPerView: 1.3,
      spaceBetween: 8,
      watchOverflow: true,
      speed: 1000,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        type: 'progressbar',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
    });
  });
}
